import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SIZE_PX = {
    xs: '12px',
    sm: '24px',
    md: '40px',
    lg: '64px',
};
const COLOR_CLASS = {
    primary: 'text-blue-600',
    secondary: 'text-gray-600',
    white: 'text-white',
};
export function LoadingSpinner({ size = 'md', className = '', color = 'primary', }) {
    const classes = ['animate-spin', COLOR_CLASS[color], className]
        .filter(Boolean)
        .join(' ');
    const inlineStyle = {
        width: SIZE_PX[size],
        height: SIZE_PX[size],
    };
    return (_jsxs("svg", { className: classes, style: inlineStyle, xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "aria-hidden": "true", "data-spinner-size": size, children: [_jsx("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }), _jsx("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })] }));
}
export default LoadingSpinner;
//# sourceMappingURL=LoadingSpinner.js.map